import {FC, useEffect, useRef, useState} from 'react'
import {chatAi} from '../../../services/urbit-gis'
import {useAi} from './useAI'
import {ErrorMessageComponent} from '../../backoffice/components/UI/ErrorMessage'
import Swal from 'sweetalert2'

type Props = {
  persona: string
  dadosAnalise: string
}
type MessageChat = {
  messageOrigem: string
  message: string
  sessionId: string
}

function BulletPointList({text}) {
  const regex = /\*\*([^*]+)\*\*/g
  const textoComNegrito = text.replace(regex, '<b>$1</b>')

  return <ul dangerouslySetInnerHTML={{__html: textoComNegrito}}></ul>
}

export default BulletPointList

export const AiChat: FC<Props> = ({persona, dadosAnalise}) => {
  const [message, setMessage] = useState<String>('')
  const [historyMessage, setHistoryMessage] = useState<MessageChat[]>([])
  const [chatId, setChatId] = useState(null)
  const {handleSubmit, register, errors, setValue} = useAi()
  const chat = useRef<HTMLDivElement>(null)
  const buttomRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    async function chatMenasgem(message) {
      let param = {
        prompt: message,
        sessionId: chatId || null,
        persona: 'especilistaIM',
        data: dadosAnalise,
      }
      console.log(param)
      let chat = await chatAi(param)
      console.log(chat)
      setChatId(chat.sessionId)

      let resultMessage = {messageOrigem: 'bot', message: chat.result, sessionId: chat.sessionId}

      // let resultMessage = {
      //   messageOrigem: 'bot',
      //   message:
      //     'Analisar o mercado imobiliário requer uma abordagem multifacetada, considerando diversos fatores interdependentes. Não existe uma única "melhor" forma, mas sim um conjunto de métodos e indicadores que, combinados, oferecem uma visão mais completa e precisa. A abordagem ideal varia dependendo do objetivo da análise (investimento, compra para moradia, desenvolvimento etc.). Aqui estão alguns dos principais aspectos a serem considerados em uma análise completa do mercado imobiliário: **1. Macroeconomia:** * **Taxas de juros:** Taxas de hipoteca impactam diretamente a demanda e os preços. Taxas baixas estimulam compras, enquanto taxas altas reduzem a procura. É crucial monitorar a política monetária do Banco Central. * **Inflação:** A inflação afeta o poder de compra e os custos de construção, impactando os preços dos imóveis. * **Crescimento econômico:** Um crescimento econômico forte geralmente impulsiona o mercado imobiliário, enquanto recessões levam à queda nos preços e na demanda. * **Emprego e renda:** A disponibilidade de empregos e níveis de renda da população influenciam a capacidade das pessoas de comprar imóveis. Observe a taxa de desemprego e a renda média da região. * **Regulamentações governamentais:** Leis de zoneamento, impostos sobre propriedade, incentivos fiscais e políticas habitacionais afetam significativamente o mercado. **2. Mercado Imobiliário Local:** * **Oferta e Demanda:** Analise a quantidade de imóveis disponíveis à venda em relação ao número de compradores potenciais. Um mercado com alta demanda e baixa oferta tende a ter preços mais altos. * **Preços de venda e aluguel:** Monitore a evolução histórica dos preços em diferentes tipos de imóveis (casas, apartamentos, terrenos) na região de interesse. Utilize indicadores como o Índice de Preços de Imóveis (IPI) se disponível para a região. * **Tipos de imóveis:** Analise a demanda por diferentes tipos de imóveis (apartamentos de luxo, casas térreas, lofts, etc.) para entender as tendências locais. * **Invenção de novos empreendimentos:** A quantidade de novos projetos imobiliários em desenvolvimento influencia a oferta futura e pode sinalizar tendências no mercado. * **Taxa de vacância:** Em mercados de aluguel, a taxa de vacância (porcentagem de imóveis vagos) indica a força da demanda. Uma taxa baixa indica um mercado forte. **3. Análise de Dados:** * **Dados históricos:** Utilize dados históricos de preços, vendas e aluguéis para identificar tendências e padrões. Sites de imobiliárias, portais de dados e órgãos governamentais podem fornecer esses dados. * **Análise comparativa:** Compare os preços e valores de imóveis semelhantes na mesma região para identificar oportunidades e outliers. * **Projeções de mercado:** Embora complexas, projeções de mercado baseadas em modelos econométricos podem auxiliar na previsão de tendências futuras, mas devem ser usadas com cautela. **4. Fatores Qualitativos:** * **Infraestrutura:** A qualidade da infraestrutura local (transportes, escolas, hospitais, segurança) afeta a atratividade de uma região. * **Localização:** A localização do imóvel é um fator crucial que influencia seu valor. Considerar proximidade com centros comerciais, áreas verdes, etc. * **Condições do imóvel:** O estado de conservação e as características do imóvel são fundamentais para determinar seu valor. **Em resumo:** Uma análise completa e eficaz do mercado imobiliário requer uma combinação cuidadosa de análise macroeconômica, dados de mercado locais, análise quantitativa de dados e consideração dos fatores qualitativos. Lembre-se que o mercado imobiliário é dinâmico e as condições podem mudar rapidamente, exigindo acompanhamento constante. Consultar especialistas, como corretores imobiliários e analistas de mercado, pode auxiliar na interpretação dos dados e na tomada de decisões.',
      //   sessionId: chatId,
      // }

      let historyMessageTemp = historyMessage
      historyMessageTemp.push({messageOrigem: 'client', message: message, sessionId: chatId})
      historyMessageTemp.push(resultMessage)
      setHistoryMessage([...historyMessageTemp])
      buttomRef.current.innerHTML = 'Enviar'
      buttomRef.current.classList.remove('disabled')
      buttomRef.current.disabled = false
      scrollChat()
    }
    if (message.length > 0) {
      chatMenasgem(message)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message])

  async function analiseInicial(message) {
    let param = {
      prompt: message,
      sessionId: chatId || null,
      persona: 'especilistaIM',
      // data: dadosAnalise,
    }
    console.log(param)
    let chat = await chatAi(param)
    console.log(chat)
    setChatId(chat.sessionId)

    let resultMessage = {messageOrigem: 'bot', message: chat.result, sessionId: chat.sessionId}
    // let resultMessage = {
    //   messageOrigem: 'bot',
    //   message:
    //     'Analisar o mercado imobiliário requer uma abordagem multifacetada, considerando diversos fatores interdependentes. Não existe uma única "melhor" forma, mas sim um conjunto de métodos e indicadores que, combinados, oferecem uma visão mais completa e precisa. A abordagem ideal varia dependendo do objetivo da análise (investimento, compra para moradia, desenvolvimento etc.). Aqui estão alguns dos principais aspectos a serem considerados em uma análise completa do mercado imobiliário: **1. Macroeconomia:** * **Taxas de juros:** Taxas de hipoteca impactam diretamente a demanda e os preços. Taxas baixas estimulam compras, enquanto taxas altas reduzem a procura. É crucial monitorar a política monetária do Banco Central. * **Inflação:** A inflação afeta o poder de compra e os custos de construção, impactando os preços dos imóveis. * **Crescimento econômico:** Um crescimento econômico forte geralmente impulsiona o mercado imobiliário, enquanto recessões levam à queda nos preços e na demanda. * **Emprego e renda:** A disponibilidade de empregos e níveis de renda da população influenciam a capacidade das pessoas de comprar imóveis. Observe a taxa de desemprego e a renda média da região. * **Regulamentações governamentais:** Leis de zoneamento, impostos sobre propriedade, incentivos fiscais e políticas habitacionais afetam significativamente o mercado. **2. Mercado Imobiliário Local:** * **Oferta e Demanda:** Analise a quantidade de imóveis disponíveis à venda em relação ao número de compradores potenciais. Um mercado com alta demanda e baixa oferta tende a ter preços mais altos. * **Preços de venda e aluguel:** Monitore a evolução histórica dos preços em diferentes tipos de imóveis (casas, apartamentos, terrenos) na região de interesse. Utilize indicadores como o Índice de Preços de Imóveis (IPI) se disponível para a região. * **Tipos de imóveis:** Analise a demanda por diferentes tipos de imóveis (apartamentos de luxo, casas térreas, lofts, etc.) para entender as tendências locais. * **Invenção de novos empreendimentos:** A quantidade de novos projetos imobiliários em desenvolvimento influencia a oferta futura e pode sinalizar tendências no mercado. * **Taxa de vacância:** Em mercados de aluguel, a taxa de vacância (porcentagem de imóveis vagos) indica a força da demanda. Uma taxa baixa indica um mercado forte. **3. Análise de Dados:** * **Dados históricos:** Utilize dados históricos de preços, vendas e aluguéis para identificar tendências e padrões. Sites de imobiliárias, portais de dados e órgãos governamentais podem fornecer esses dados. * **Análise comparativa:** Compare os preços e valores de imóveis semelhantes na mesma região para identificar oportunidades e outliers. * **Projeções de mercado:** Embora complexas, projeções de mercado baseadas em modelos econométricos podem auxiliar na previsão de tendências futuras, mas devem ser usadas com cautela. **4. Fatores Qualitativos:** * **Infraestrutura:** A qualidade da infraestrutura local (transportes, escolas, hospitais, segurança) afeta a atratividade de uma região. * **Localização:** A localização do imóvel é um fator crucial que influencia seu valor. Considerar proximidade com centros comerciais, áreas verdes, etc. * **Condições do imóvel:** O estado de conservação e as características do imóvel são fundamentais para determinar seu valor. **Em resumo:** Uma análise completa e eficaz do mercado imobiliário requer uma combinação cuidadosa de análise macroeconômica, dados de mercado locais, análise quantitativa de dados e consideração dos fatores qualitativos. Lembre-se que o mercado imobiliário é dinâmico e as condições podem mudar rapidamente, exigindo acompanhamento constante. Consultar especialistas, como corretores imobiliários e analistas de mercado, pode auxiliar na interpretação dos dados e na tomada de decisões.',
    //   sessionId: chatId,
    // }

    Swal.hideLoading()
    let historyMessageTemp = historyMessage
    historyMessageTemp.push({messageOrigem: 'client', message: message, sessionId: chatId})
    historyMessageTemp.push(resultMessage)
    setHistoryMessage([...historyMessageTemp])
  }

  function onSubmit(data) {
    setMessage(data.mensagem)
    console.log(buttomRef)
    buttomRef.current.innerHTML = 'Enviando....'
    buttomRef.current.classList.add('disabled')
    buttomRef.current.disabled = true
    // inputMessage.current.value = ''
    setValue('mensagem', '')
  }

  function scrollChat() {
    if (chat.current) {
      const element = chat.current
      element.scrollTop = element.scrollHeight - 100
    }
  }

  function analisarComIA(e) {
    e.target.classList.add('hide')

    console.log(dadosAnalise)
    Swal.fire('Carregando dados para IA...')
    Swal.showLoading()
    chat.current.classList.remove('hide')

    // setTimeout(() => {
    analiseInicial(dadosAnalise)
    // }, 5000)
  }

  // function BulletPointList(text) {
  //   const regex = /\*\*([^*]+)\*\*/g
  //   const textoComNegrito = text.replace(regex, '<b>$1</b>')

  //   return <ul dangerouslySetInnerHTML={{__html: textoComNegrito}}></ul>
  // }

  return (
    <div>
      <div className='row'>
        <div className='col-12 d-flex justify-content-end'>
          <button
            className='btn btn-primary mb-5'
            onClick={(e) => {
              analisarComIA(e)
            }}
          >
            Analisar relatório com AI
          </button>
        </div>
      </div>

      <div className='card pt-10 bgi-no-repeat card-xl-stretch mb-xl-8 border-2 box-performance'>
        <div className='row g-5 g-xl-8'>
          <section className='chat hide' ref={chat}>
            <section className='chat__messages'>
              {historyMessage.map((item, index) => {
                if (index > 0) {
                  if (item.messageOrigem === 'bot') {
                    return (
                      <div className='message--other' key={index}>
                        <h1>Urbit AI</h1>
                        <p className='pull-left'>
                          {item.message.split('\n').map(function (item, idx) {
                            return (
                              <span key={idx}>
                                {item}
                                <br />
                              </span>
                            )
                          })}
                        </p>
                      </div>
                    )
                  } else {
                    return (
                      <div className='message--self' key={index}>
                        <h1>Mensagem Cliente</h1>
                        <p className='pull-left'>
                          {item.message.split('\n').map(function (item, idx) {
                            return (
                              <span key={idx}>
                                <BulletPointList text={item} />
                                <br />
                              </span>
                            )
                          })}
                        </p>
                      </div>
                    )
                  }
                }
              })}
            </section>

            <form className='chat__form' onSubmit={handleSubmit(onSubmit)}>
              <input
                type='text'
                defaultValue={''}
                className='chat__input form-control'
                placeholder='Digite sua perguta ou dúvida'
                required
                {...register('mensagem', {required: true})}
              />
              <button type='submit' ref={buttomRef} className='chat__button btn btn-sm btn-info'>
                Enviar
              </button>
            </form>
            <ErrorMessageComponent
              message={errors ? errors.mensagem?.message : ''}
            ></ErrorMessageComponent>
          </section>

          {/* <div className='chat' id='chat' ref={chat}></div> */}
        </div>
      </div>
    </div>
  )
}
